<script setup>
import { useStore } from "vuex";
import { computed, watch } from "vue";
import { useCustomRoute } from "@/composables/useCustomRoute";
import { useRouter } from "vue-router";
import RouteNames from "@/router/RouteNames";
import ModalContainer from "@/components/modals/ModalContainer.vue";

const store = useStore();
const loading = computed(() => store.state.loading);
const userId = computed(() => store.getters.userId);

const router = useRouter();

const { requiresAuth } = useCustomRoute();

watch(userId, async (value) => {
  if (!value && requiresAuth.value) {
    await router.push({ name: RouteNames.MainView });
  }
});
</script>

<template>
  <div class="loading" v-show="loading"></div>
  <router-view />
  <modal-container />
</template>

<style scoped>
.loading {
  z-index: 2000;
  background-color: #ffffff;
}
.loading:before {
  content: "";
  position: absolute;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
}
</style>
